// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-modal .modal-content {
    max-height: 85vh;
}

.settings-modal .modal-body {
    overflow-x: auto;
}

.user-settings {
    padding: 1.5rem;
    border-radius: 8px;
    background: #fafafa;
    border: 1px solid #ddd;
    max-width: 480px;
    width: 100%;
}

.user-settings-title {
    margin: 0 0 1rem 0;
    font-size: 1.4rem;
    font-weight: 600;
}

.user-settings-group {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
}

.user-settings-label {
    font-size: 0.95rem;
    margin-bottom: 0.4rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

    .user-settings-label.disabled{
        color:var(--color-disabled-fore);
    }

    .user-settings-save {
        margin-top: 1rem;
        padding: 0.6rem 1rem;
        font-size: 1rem;
        border-radius: 6px;
        border: none;
        background: #0078d4;
        color: white;
        cursor: pointer;
    }

    .user-settings-save:hover {
        background: #005fa3;
    }

.user-settings-select {
    width: 140px;
    padding: 0.4rem;
    font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./src/Settings/css/UserSettings.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;IAEI;QACI,gCAAgC;IACpC;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["@import '../../css//App.css';\r\n\r\n.settings-modal .modal-content {\r\n    max-height: 85vh;\r\n}\r\n\r\n.settings-modal .modal-body {\r\n    overflow-x: auto;\r\n}\r\n\r\n.user-settings {\r\n    padding: 1.5rem;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    border: 1px solid #ddd;\r\n    max-width: 480px;\r\n    width: 100%;\r\n}\r\n\r\n.user-settings-title {\r\n    margin: 0 0 1rem 0;\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.user-settings-group {\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.user-settings-label {\r\n    font-size: 0.95rem;\r\n    margin-bottom: 0.4rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n}\r\n\r\n    .user-settings-label.disabled{\r\n        color:var(--color-disabled-fore);\r\n    }\r\n\r\n    .user-settings-save {\r\n        margin-top: 1rem;\r\n        padding: 0.6rem 1rem;\r\n        font-size: 1rem;\r\n        border-radius: 6px;\r\n        border: none;\r\n        background: #0078d4;\r\n        color: white;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .user-settings-save:hover {\r\n        background: #005fa3;\r\n    }\r\n\r\n.user-settings-select {\r\n    width: 140px;\r\n    padding: 0.4rem;\r\n    font-size: 0.95rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
